"use client"

import { Link } from "react-router-dom"
import { motion } from "framer-motion"

import { Card } from "@/components/ui/card"
import { cn } from "@/core/lib/utils"

import type { PlaylistCardProps } from "./types"
import usePlaylistCard from "./hooks/usePlaylistCard"

import PlaylistCardImage from "./components/PlaylistCardImage"
import PlaylistCardPlayButton from "./components/PlaylistPlayButton"

export default function PlaylistCardS({
  data,
}: PlaylistCardProps) {
  const {
    loaded,
    setLoaded,
    isThisPlay,
    isPlaying,
    totalPlaylistTime,
    changeTheme,
    handlePlay,
  } = usePlaylistCard(data)

  return (
    <motion.div
      className="group relative w-42 md:w-48 shrink-0"
      style={{
        WebkitUserSelect: "none",
      }}
    >
      <Card
        className={cn(`
          relative z-0
          w-42 md:w-48
          aspect-[2/2]
          h-full
          gap-0
          overflow-hidden
          rounded-md
          bg-transparent
          p-1.5 md:p-2.5
          shadow-none
          select-none
          justify-center
          items-center
          group-hover:bg-[var(--primary-color)]/20 //bg-white

          pointer-events-auto       
          active:scale-97
          touch-active:scale-95     
          transition-transform
          duration-300

        `)}   //w-37
      >
        <PlaylistCardImage
          title={data.title}
          imgUrl={data.imgUrl}
          loaded={loaded}
          setLoaded={setLoaded}
          showPlay={isThisPlay}
          isPlaying={isPlaying}
          canvasActive={true}
          duration={totalPlaylistTime}
        />

        <Link
          to={`/${data.type}/${data.link}`}
          onMouseEnter={changeTheme}
          aria-label={`Abrir ${data.title}`}
          className="
            absolute
            inset-0
            z-10
            rounded-xl
          "
        />

        <div
          className="
            absolute
            right-1 md:right-2
            bottom-9 md:bottom-11.5
            z-[100]
            pointer-events-auto
          "
        >
          <PlaylistCardPlayButton
            show={isThisPlay}
            isCurrentPlaylist={isThisPlay}
            isPlaying={isPlaying}
            onPlay={handlePlay}
          />
        </div>
      </Card>
    </motion.div>
  )
}